/**
 * @desc OMS包裹拦截
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OrderApplyOperationRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/outPlan/intercept`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
